export default {
    activeList:[ {
            title:'木荷盛放，温情如初——致敬母爱与护理之光',
            time:'2024年5月12日至5月12日',
            unit:'广州市流溪河国家森林公园管理中心',
            place:'流溪湖景区',
            img:'https://www.lxhpark.cn/img/hunter02.png',
            imgList:['https://www.lxhpark.cn/img/hunter02.png','https://www.lxhpark.cn/img/hunter03.png'],
            detail:'在岁月的长河中，有一种植物，默默地绽放，不为争春，只为那份恬静而坚定的守护。它，就是木荷，以其独特的姿态，诉说着生命的故事。在这个母亲节与护士节交织的特殊时刻，我们诚挚邀请您走进流溪河国家森林公园，感受木荷的温婉与坚韧，同时，将我们的敬意和感激，献给伟大的母亲与护士。大自然的守护神“木荷树”'
+'木荷树被誉为大自然的守护神，主要是因为它既是一种优良的绿化和用材树种，同时也是一种具有耐火、抗火特性的树种。木荷树的这些功能使其在自然界中扮演了重要的角色，对于维护生态平衡和保护生物多样性有着不可忽视的贡献。因此，木荷树被人们尊称为“大自然的守护神”。'
+'木荷花也极具观赏价值，其花色艳丽，有深红、粉红、白色等多种颜色。花朵形态优雅，宛如一个个精致的小灯笼，挂满了枝头。它们的花期较长，能从春季一直延续到秋季，给人们带来四季不断的观赏享受。'
+'流溪河国家森林公园的木荷花正开得灿烂，素雅的花瓣，坚韧的花茎，成为了景区中的一道亮丽风景线。淡淡的香气随风飘散，不仅香味宜人，而且这些芳香物质也有益于人类身体健康，可以说木荷是极好的康养树种，木荷林是极好的康养林。'
+'此外，木荷还有着丰富的实用价值。其芳香物质可制作香精油，具有很高的经济用途。而木荷树的木材坚硬、耐用，可用于制作家具、农具等。'
+'在这里，您不仅能够领略到大自然的鬼斧神工，更能够在这片花海中找到心灵的慰藉。木荷花的盛开，是对母爱与护理之光的美好诠释，也是我们对您深情的邀请。'
+'双节福利回馈'
+'为表达对天下所有母亲的敬爱，对所有辛勤护士的感激，我们特别推出双节福利回馈活动。凡是在节日当天到访景区的母亲和护士，可凭有效证件免费领取一支由景区特别定制的纪念笔作为节日礼物。'
          },{
            title:'门票优惠政策活动',
            time:'2023年5月4日至6月30日',
            unit:'广州市流溪河国家森林公园管理中心',
            place:'流溪湖景区、五指山景区',
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/1.jpg',
            imgList:[],
            detail:'为增加亲子游人气，对亲子游家庭实行随行家庭凡购2张成人票送3张儿童票（限14周岁以下儿童）；'
          },{
            title:'盛夏激凉，声动流溪',
            time:'2023年7月14日-8月13日',
            timeDetail:'(10:00-11:30,14:20-15:30)',
            unit:'广州市流溪河国家森林公园管理中心',
            place:'广州市流溪河国家森林公园五指山景区青年山庄泼水广场',
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/4.jpg',
            imgList:[],
            detail:'“五指山泼水狂欢节”的独特之处在于活动选址在海拔约600米的山林溪涧旁，气温比市区低4-5℃，空气负氧离子达25000个/㎝³，有得天独厚的森林“小气候”；现场泳池采用清洁的山溪活水，体感清凉，富含矿物质，泼水消暑之余还有美肤康养的功效，给游客一个名副其实的“激凉夏日”。'
          }],
          jidiList:[{
            title:'康养基地介绍',
            time:'2023年5月4日至6月30日',
            unit:'广州市流溪河国家森林公园管理中心',
            place:'流溪湖景区、五指山景区',
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/kangyang/kangyang1.jpg',
            imgList:['https://hi.cxtrip.cc/cxyTicket/lxh/kangyang/kangyang1.jpg','https://hi.cxtrip.cc/cxyTicket/lxh/kangyang/kangyang3.jpg'],
            detail:`流溪河国家森林公园作为广东省森林康养基地（试点），这里植被类型多样、种群结构完整、生物多样性丰富、森林植被景观秀美。基地以优质的森林资源为依托，融入旅游、休闲、运动、养生、体验等健康服务新理念，开发多样森林康养产品和服务，打造康养福地的形象。
   小气候环境优越，提供康体养生体验。基地森林覆盖率达80.3%，海拔较高，森林茂密，四季分明，林木吸收了大部分日光能和辐射能，形成良好的小气候，年平均气温20.3度，是南国避暑胜地。据测定，基地内大气污染物浓度低于国家《大气环境质量》一级标准5-12倍，环境大气质量优于国家一级质量标准。同时，空气负离子浓度高，根据最新测定，空气负离子浓度平均高达15423个/cm³。空气细菌含量低，基地内一些树木能分泌出浓烈芳香植物杀菌素，形成一个抗菌地带，为前来的游客提供舒适宜人的养生环境。
多种康养步道，提供疗养、运动健身等服务。夏湾半岛滨湖休闲环湖绿道和栈道穿梭于森林内，景色优美，视野开阔，在此可进行有氧徒步或骑自行车，具有疗愈功能，为亚健康、老年人和健康人群提供康养场所；另外，三桠塘幽谷登山游步道和五指山登山步道位于公园五指山景区，通过登山等户外运动的形式，提供在森林里健身锻炼的机会。
`
          },{
            title:'自然教育基地介绍',
            time:'2023年7月14日-8月13日',
            unit:'广州市流溪河国家森林公园管理中心',
            place:'广州市流溪河国家森林公园五指山景区青年山庄泼水广场',
            img:'https://hi.cxtrip.cc/cxyTicket/lxh/jiaoyu/jiaoyu1.jpg',
            imgList:['https://hi.cxtrip.cc/cxyTicket/lxh/jiaoyu/jiaoyu1.jpg','https://hi.cxtrip.cc/cxyTicket/lxh/jiaoyu/jiaoyu2.jpg','https://hi.cxtrip.cc/cxyTicket/lxh/jiaoyu/jiaoyu3.jpg'],
            detail:`流溪河国家森林公园自然教育基地是利用森林公园自然景观和资源的优势，充分发挥保护生物多样性和维护生态平衡的作用，通过建立面向公众开放的自然教育区域，开展自然教育活动，实现生态保护和教育的功能。
基地拥有优质的森林资源、植物资源、动物资源、水文景观资源、地文景观资源、天文景观资源和人文景观资源。今年先后被认定为全国林草科普基地、广东省自然教育基地、广州市中小学生研学实践教育基地、广州市港澳青少年研学实践教育基地和广州市少先队校外实践教育营地（基地）。
据记录，基地覆盖有季风常绿阔叶林等九类森林景观。共有野生维管植物1295种，其中国家Ⅱ级重点保护野生植物22种，中国珍稀濒危保护的野生植物12种。物种起源古老，不乏第三纪或更古老的残遗或孑遗植物，具有较高的科学研究、科普教育价值。珍稀植物有蛇足石杉、福建观音座莲、金毛狗、桫椤、苏铁蕨、穗花杉、福建柏、厚叶木莲、伯乐树、软荚红豆、花榈木、巴戟天、金线兰等。丰富多样的环境，为野生动物生存发展创造了良好的栖息地：基地内生存有野生脊椎动物316种，鸟类145种，其中国家Ⅰ级保护动物4种，国家Ⅱ级保护动物32种。野生动物景观以鸟类可见频度最高，其中鹭科鸟类具有相对最大的观赏和保护价值。在流溪湖湾畔等地，是保护鹭科鸟类等野生动物最有价值的区域，也是观赏鹭科鸟类和学习保护野生动物极好地带。
基地深入挖掘溪流河生态文化，以“生态保护、动物保护、植物保护和自然疗愈”为主题，通过体验性、互动性的自然教育设施建设，开发适合不同年龄段尤其是青少年自然教育课程，开展常态化自然教育活动，提供探索知识性、文化性、趣味性和互动性相结合的自然教育体验，并展现流溪河国家森林公园生态系统、动植物资源及地方特色资源，将打造成广州市近郊沉浸式体验的自然教育示范基地。
`
          }],
}